const responsiveImage = `
responsiveImage(imgixParams: {fm: jpg, fit: crop, maxH: 800}, sizes: "(max-width: 1600px) 100vw, 1600px"){
  srcSet
  webpSrcSet
  sizes
  src
  aspectRatio
  alt
  title
}
`

const nativeAdFields = `
  slug,
  mainHeading,
  mainImage {
    url
  },
  checkmarkList {
    text
  },
  showAppRating,
  showReviews,
  showAppButtons,
  content {
    __typename
    ... on ImageBlockRecord {
      image {
        ${responsiveImage}
      },
      alignment
    }
    ... on WidgetRecord {
      component
    }
    ... on TextBlockRecord {
      bodyCopy
    }
  },
  callout,
  companyImprint,
  cta {
    color,
    buttonText,
    useOfficialButton
  }
`

module.exports = {
  query: (slug, locale) => `
    {
      nativeAdPage(filter: {slug: {eq: "${slug}"}}, locale: ${locale}) {
        ${nativeAdFields}
      }
    }
  `,
  queryAll: locale => `
  {
    allNativeAdPages(locale: ${locale}) {
      ${nativeAdFields}
    }
  }
  `,
}
